import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import translatedLanguages from "./translation";
import moment from "moment";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    resources: translatedLanguages,
    fallbackLng: "en-US", // use en if detected lng is not available
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on("languageChanged", (lng) => {
  if (lng) {
    const locale = lng.split("-")[0];
    moment.locale(locale);
  }
});

export default i18n;
